import { Component } from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="grid min-h-screen place-items-center bg-cream px-6 text-center">
                    <div>
                        <p className="font-serif text-3xl font-semibold text-cocoa">
                            Something crumbled...
                        </p>
                        <p className="mt-3 text-cocoa-soft">
                            Please refresh the page — your cake will be right back.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
